<template>
  <div class="mb-5">
    <div class="report-icons">
      <a v-if="showValidate" @click="$emit('validate')" class="validate-icon" title="Validate report">
        <font-awesome-icon icon="check-circle" />
      </a>
      <a @click="createPdf" class="pdf-icon">
        <img src="@/assets/images/pdf.png" alt="PDF" height="32" />
      </a>
    </div>
    <div id="totalsales-report" className="xz-report">
      <TurnoverReportHeader :location="location" :terminal="terminal" :fromDate="fromDate" :toDate="toDate" />
      <TurnoverReportTotalSales :zReports="zReports" :vat="vat" />
      <TurnoverReportCategories :zReports="zReports" :vat="vat" />
      <TurnoverReportSalesPayments :zReports="zReports" :vat="vat" />
      <TurnoverReportRefund :zReports="zReports" :vat="vat" :saftSource="saftSource" />
    </div>
  </div>
</template>

<script>
import TurnoverReportHeader from "@/components/report/turnover/TurnoverReportHeader.vue";
import TurnoverReportTotalSales from "@/components/report/turnover/TurnoverReportTotalSales";
import TurnoverReportCategories from "@/components/report/turnover/TurnoverReportCategories";
import TurnoverReportSalesPayments from "@/components/report/turnover/TurnoverReportSalesPayments";
import TurnoverReportRefund from "@/components/report/turnover/TurnoverReportRefund";

import ReportPdfBuilder from "@/util/ReportPdfBuilder";

export default {
  components: {TurnoverReportHeader, TurnoverReportTotalSales, TurnoverReportCategories, TurnoverReportSalesPayments, TurnoverReportRefund},
  props: {
    zReports: Array,
    vat: Object,
    company: Object,
    location: Object,
    terminal: Object,
    fromDate: String,
    toDate: String,
    saftSource: { type: Boolean, default: false },
    showValidate: { type: Boolean, default: false }
  },
  emits: ['validate'],
  methods: {
    createPdf() {
      ReportPdfBuilder.buildTurnoverReportPdf(this.zReports, this.location, this.terminal, this.vat, this.fromDate, this.toDate, this.saftSource);
    }
  }
}
</script>

<style scoped>
.report-icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 40px;
}
.report-icons .pdf-icon {
  margin-top: 0;
  display: inline;
}
.validate-icon {
  cursor: pointer;
  font-size: 28px;
  color: var(--bo-ink);
}
.validate-icon:hover {
  color: #0d6efd;
}
</style>
